import React, { useEffect, useState } from 'react'
import { NOVITA, novitaDaMostrare, dataUltimaNovita, dividiNovita, RUOLI_CHE_VEDONO_LE_NOVITA } from '../novita'
import { RED } from './shared'

// NovitaAvvio — il riquadro che compare all'apertura del programma con quello che è cambiato:
// prima le CORREZIONI (errata corrige) e poi le IMPLEMENTAZIONI (cose nuove).
//
// Perché all'apertura e non in una pagina da cercare: chi usa il gestionale ogni giorno non ha modo
// di sapere cosa è cambiato, e se ne accorge per caso. Si mostra una volta sola: la data dell'ultima
// novità vista resta in questo browser, e chi è già aggiornato non lo rivede.
//
// Nota: le novità vecchie si mostrano solo a chi non ha mai visto niente? No: in quel caso si
// mostrano SOLO quelle dell'ultimo giorno (vedi novitaDaMostrare), così un utente nuovo non si trova
// davanti mesi di cronaca.
const CHIAVE_VISTO = 'sportly_novita_viste'

function NovitaAvvio({ ruolo }) {
  const [daMostrare, setDaMostrare] = useState([])
  const [aperto, setAperto] = useState(false)

  useEffect(() => {
    try {
      if (!RUOLI_CHE_VEDONO_LE_NOVITA.includes(ruolo)) return
      const visto = window.localStorage.getItem(CHIAVE_VISTO)
      const nuove = novitaDaMostrare(visto)
      if (nuove.length > 0) {
        setDaMostrare(nuove)
        setAperto(true)
      }
    } catch (e) {
      // Se il browser blocca la memoria locale, non si mostra niente: meglio di un errore all'avvio.
      console.warn('[novità] non riesco a leggere la memoria locale:', e?.message || e)
    }
  }, [ruolo])

  if (!aperto || daMostrare.length === 0) return null

  const { correzioni, implementazioni } = dividiNovita(daMostrare)

  const chiudi = () => {
    try {
      window.localStorage.setItem(CHIAVE_VISTO, dataUltimaNovita(NOVITA) || '')
    } catch (e) { /* niente: si rivedrà la prossima volta */ }
    setAperto(false)
  }

  const Sezione = ({ titolo, colore, sfondo, voci }) => (!voci.length ? null : (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: colore, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 6 }}>{titolo}</div>
      {voci.map((n, i) => (
        <div key={i} style={{ background: sfondo, border: `1px solid ${colore}33`, borderRadius: 8, padding: '8px 10px', marginBottom: 6 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#222', marginBottom: 2 }}>{n.titolo}</div>
          <div style={{ fontSize: 12, color: '#555', lineHeight: 1.45 }}>{n.testo}</div>
        </div>
      ))}
    </div>
  ))

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 14, maxWidth: 620, width: '100%', maxHeight: '85vh', overflowY: 'auto', padding: 20, boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 4 }}>
          <div style={{ fontSize: 17, fontWeight: 700, color: RED }}>🆕 Cosa è cambiato</div>
          <div style={{ fontSize: 11, color: '#999' }}>{daMostrare.length} novità</div>
        </div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
          Il riepilogo di quello che è stato corretto e di quello che è stato aggiunto. Lo vedi una volta sola: alla prossima apertura non ricompare.
        </div>
        <Sezione titolo="🔧 Errata corrige (correzioni)" colore="#b36a00" sfondo="#fffaf0" voci={correzioni} />
        <Sezione titolo="✨ Implementazioni (novità)" colore="#1a7a3a" sfondo="#f4fbf6" voci={implementazioni} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
          <button onClick={chiudi}
            style={{ background: RED, color: 'white', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            Ho capito
          </button>
        </div>
      </div>
    </div>
  )
}

export default NovitaAvvio
